<div class="containerBox flex-column">
	<div class="navigation" [class.navShown]="!us.sidebarToggle">
		<div class="navigation__topbar display-sm">
			<button mat-button color="primary" type="button" class="topbar-user-btn waw-btn _second display-sm" (click)="us.userPopup = !us.userPopup;">
				<span class="icon-plus"></span>
				<span>New client</span>
			</button>
		</div>
		
		<div class="navigation__search">
			<datepicker type="dashboard" [date]="dashboard.selector" [interval]="dashboard.interval" [readonly]="true" (valueChange)="dashboard.periodChange($event)"></datepicker>
		</div>

		<div class="navigation__tab">
			<tab [(value)]="dashboard.tab" (valueChange)="dashboard.tab = $event" [tabs]="dashboard.tabs"></tab>
		</div>

		<div class="navigation__right _filter">
			<div class="navigation__filter">
				<div class="navigation__filter-location">
					<app-select 
						placeholder="Location" 
						[(value)]="dashboard.location" 
						(valueChange)="dashboard.locationChange($event)" 
						[items]="loc.locations" 
						bindLabel="name" 
						bindValue="_id" 
						icon="location" 
						class="_filter"
					></app-select>
				</div>
			</div>
		</div>
	</div>

	<div class="containerTab fl-grow">
		<!-- Overview Tab -->
		<ng-container *ngIf="dashboard.tab == 'overview'">
			<app-dashboard-overview
				[interval]="dashboard.interval"
				[selector]="dashboard.selector"
				[location]="dashboard.location"
			></app-dashboard-overview>
		</ng-container>
	
		<!-- Appointments Tab -->
		<ng-container *ngIf="dashboard.tab == 'appointments'">
			<app-dashboard-appointments
				[interval]="dashboard.interval"
				[selector]="dashboard.selector"
				[location]="dashboard.location"
			></app-dashboard-appointments>
		</ng-container>
	
		<!-- Sales Tab -->
		<ng-container *ngIf="dashboard.tab == 'sales'">
			<app-dashboard-sales
				[interval]="dashboard.interval"
				[selector]="dashboard.selector"
				[location]="dashboard.location"
			></app-dashboard-sales>
		</ng-container>
	
		<!-- Clients Tab -->
		<ng-container *ngIf="dashboard.tab == 'clients'">
			<app-dashboard-clients
				[interval]="dashboard.interval"
				[selector]="dashboard.selector"
				[location]="dashboard.location"
			></app-dashboard-clients>
		</ng-container>
	
		<!-- Staff Tab -->
		<ng-container *ngIf="dashboard.tab == 'staff'">
			<app-dashboard-staff
				[interval]="dashboard.interval"
				[selector]="dashboard.selector"
				[location]="dashboard.location"
			></app-dashboard-staff>
		</ng-container>
	</div>
</div>
